import { useTranslation } from "react-i18next";
import { ChevronDown } from "lucide-react";

export const FaqSection = () => {
  const { t } = useTranslation();
  const items = t("faq.items", { returnObjects: true });
  return (
    <section id="faq" className="mx-auto max-w-4xl px-4 sm:px-6 py-20" data-testid="faq-section" aria-labelledby="faq-title">
      <span className="text-xs font-semibold uppercase tracking-wider text-amber-600">{t("faq.eyebrow")}</span>
      <h2 id="faq-title" className="mt-2 font-heading text-3xl font-extrabold sm:text-4xl">{t("faq.title")}</h2>
      <div className="mt-8 divide-y divide-slate-200 rounded-2xl border border-slate-200 bg-white">
        {Array.isArray(items) && items.map((it, i) => (
          <details key={it.q} className="group p-5 sm:p-6" open={i === 0} data-testid={`faq-item-${i}`}>
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-heading text-lg font-bold text-slate-900">
              <h3>{it.q}</h3>
              <ChevronDown className="h-5 w-5 shrink-0 text-amber-600 transition-transform group-open:rotate-180" />
            </summary>
            <p className="mt-3 text-base leading-relaxed text-slate-600">{it.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
};
